import { Map } from "immutable";
import { LOAD_CITY_RUMORS } from "../actions/cityRumors.actions";

const initialState = Map({
	dataIsLoading: true,
	cityRumors: []
});

export default function (state = initialState, action) {
	switch(action.type) {
		case LOAD_CITY_RUMORS:
			state = state
				.set('cityRumors', action.payload.cityRumors)
				.set('dataIsLoading', false);
			return state;
			
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/cityRumors.reducer.js